module.exports = __webpack_public_path__ + "static/embedded-act-group-839bee279e0d0fb26cf65e40e490d901.png";